// import browser from '@/util/browser'

export default [{
  path: '/goods/:goodsId/add_friend_teacher',
  component: () => import('../views/page/goods/add_friend_teacher.vue')
}, {
  path: '/goods/:goodsId/detail',
  name: 'goods.detail',
  meta: {
    title: 'VIPKID | 启蒙英语'
  },
  component: () => {
    return import('@/views/page/goods/detailApp.vue')// 针对老版本app创建的空页面，不可购课，即将下线，不用修改
  },
  props: true
}, {
  path: '/goods/:goodsId/webdetail',
  name: 'goods.webdetail',
  meta: {
    title: 'VIPKID | 启蒙英语'
  },
  component: () => {
    return import('@/views/page/goods/detail.vue')// 正常购课用的页面
  },
  props: true
}, {
  path: '/goods/:goodsId/discount_detail',
  name: 'goods.discountWebDetail',
  meta: {
    title: 'VIPKID | 启蒙英语'
  },
  component: () => {
    return import('@/views/page/goods/discount_detail.vue')
  },
  props: true
}, {
  path: '/goods/slight_course_guide',
  name: 'goods.slightCourseGuide',
  meta: {
    title: 'VIPKID | 启蒙英语'
  },
  component: () => {
    return import('@/views/page/goods/slightCourseGuide.vue')
  },
  props: true
}]
// slightCourseGuide
